import { render, staticRenderFns } from "./HealthcareExpenseNavigation.vue?vue&type=template&id=2467954c&scoped=true"
import script from "./HealthcareExpenseNavigation.vue?vue&type=script&lang=ts"
export * from "./HealthcareExpenseNavigation.vue?vue&type=script&lang=ts"
import style0 from "./HealthcareExpenseNavigation.vue?vue&type=style&index=0&id=2467954c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467954c",
  null
  
)

export default component.exports